module.exports = __webpack_public_path__ + "favicon-32x32.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/favicon/favicon-32x32.png
// module id = 1814
// module chunks = 0